import BaseComponent from "../../../../../lib/components/BaseComponent";
import FieldSelection from "./FieldSelection";
import GF from "../../../../../lib/utils/GF";
import {createRef} from "react";

class FieldSelectionContainer extends BaseComponent {

  constructor(props) {
    super(props);
    this.fieldSelectionRef = createRef();

    this.state = {
      fieldMappingDescription: [],
      fieldMappingFieldName: [],
      response: null,
      collectedValues: null,
      records: null,
      fieldMapping: []
    };
  }

  collectValues(records) {
    let collection = [];
    for (let rowId in records) {
      if (rowId !== '0') {
        let record = records[rowId];
        for (let fieldIndex in record) {
          let fieldValue = record[fieldIndex];
          fieldIndex = parseInt(fieldIndex);
          if (GF.checkNotNUllAndNotEmpty(collection[fieldIndex])) {
            collection[fieldIndex] += ' | ';
          } else {
            collection[fieldIndex] = '';
          }
          collection[fieldIndex] += fieldValue;
        }
      }
    }
    return collection;
  }

  findColumnValue(fieldValue) {
    return this.state.fieldMappingDescription.indexOf(fieldValue);
  }

  updateFieldMapping(position, option) {
    if (option === '-1') {
      this.state.fieldMapping[position] = '';
    } else {
      this.state.fieldMapping[position] = option;
    }
  }

  getFieldMapping() {
    return this.state.fieldMapping;
  }

  initFieldMappingDescription(fieldDefs) {
    this.state.fieldMappingDescription[-1] = '';
    this.state.fieldMappingFieldName[-1] = '';
    for (let index in fieldDefs) {
      let fieldDef = fieldDefs[index];
      this.state.fieldMappingDescription.push(fieldDef.description);
      this.state.fieldMappingFieldName.push(fieldDef.name);
    }
  }

  initMapping(response) {
    this.state.response = response;
    this.initFieldMappingDescription(response.data.fieldDefs);
    this.state.collectedValues = this.collectValues(response.data.records);

    this.state.records = [];
    if (this.state.response !== null) {
      for (let fieldIndex in response.data.records[0]) {
        let fieldCol = response.data.records[0][fieldIndex];
        let fieldValue = this.state.collectedValues[fieldIndex];
        this.addFieldToMapping(this.findColumnValue(fieldCol));
        this.state.records.push({
          column: fieldCol, value: fieldValue + ' ...', fieldSelection: this.findColumnValue(fieldCol)
        });
      }
    }
    this.setState(this.state);
  }

  addFieldToMapping(field) {
    this.state.fieldMapping.push(this.state.fieldMappingFieldName[field]);
  }

  render() {
    let fieldSelectionCard;
    if (this.state.response !== null) {
      fieldSelectionCard = <FieldSelection ref={this.fieldSelectionRef} className='mb-12' records={this.state.records}
                                           fieldMapping={this.state.fieldMappingFieldName} fieldMappingDescription={this.state.fieldMappingDescription} onMappingChanged={(position, option) => this.updateFieldMapping(
        position, option)}/>;
    } else {
      fieldSelectionCard = <></>;
    }
    return fieldSelectionCard;
  }
}

export default FieldSelectionContainer;
